import React, { useState, useRef, useEffect, useCallback } from "react"
import { useTranslation } from "next-i18next"

import { useDispatch, useSelector } from "react-redux"
import { getConfig } from "@/constants/config"
import { FULL_FAVORITE_BASE64, EMPTY_FAVORITE_BASE64 } from "@/constants"
import _get from "lodash/get"
import { selectFavoritesState } from "@/store/features/favoritesSlice"
import MiniCart from "@/components/Shared/MiniCart/v1/MiniCart"
import debounce from "lodash.debounce"
import utilityStyles from "@/components/Shared/UtilityWidgets/v1/UtilityWidgets.module.scss"

import { getTranslations } from "@/components/Default/DynamicSearch/v1/SearchPanel/localization"

import {
  getUserPersona,
  getPDPUrl,
  sanitizeTextForAnalytics,
  getShortenedUrl,
  sanitizeUrl,
  getFavouraties,
  getCompareData,
  removeAndCleanLink,
  addMavenoidChat,
  removeMavenoidChat,
} from "@/utils/helper"
import {
  profileBrandSearch,
  profileServicePartsSearch,
  profileBrandTypeahead,
} from "@/store/features/productListSlice"

import { setSearchPresetConfig } from "@/store/features/searchSlice"

import dynamic from "next/dynamic"
import {
  selectAuthState,
  setAuthModalVisibility,
} from "@/store/features/authSlice"
import { addToCompareProduct, removeFromCompareProduct } from "@/utils/product"
import { getPdpRedirectUrl } from "@/utils/"

import useIsSsr from "@/hooks/useIsSsr"
import { useRouter } from "next/router"
import useWindowDimensions from "@/hooks/useWindowDimensions"
import { isMobile } from "react-device-detect"

const SearchPanel = dynamic(() =>
  import("@/components/Default/DynamicSearch/v1/SearchPanel")
)

const UtilityWidgets = props => {
  const iconSearch = "/icons/search-Icon.svg"
  const { t } = useTranslation("common")
  const { searchHeader = "" } = getTranslations(t)
  const router = useRouter()

  let analyticsEventData = {}
  const { columnClassNames, data, eventHandler } = props
  const { isAuth } = useSelector(selectAuthState)
  const dispatch = useDispatch()
  const persona = getUserPersona()
  const isSsr = useIsSsr()
  const currencySign = useRef("")
  const currencyCode = useRef("")
  const searchPagePath = useRef("")
  const knowledgeArticleUrl = useRef("")

  const [showSearchBar, setShowSearchBar] = useState(false)
  const [selectedData, setSelectedData] = useState({})
  const [searchString, setSearchString] = useState("")
  const [searchHistory, setSearchHistory] = useState(
    JSON.parse(localStorage.getItem("keyWordList")) ?? []
  )
  const [brandName, setBrandName] = useState("kohler")
  const [prevSearch, setPrevSearch] = useState("")
  const [searchTotal, setSearchTotal] = useState(0)
  const [searchProfileTotal, setSearchProfileTotal] = useState(0)
  const [topSuggestedData, setTopSuggestedData] = useState("")
  const [isCTAClicked, setIsCTAClicked] = useState(false)
  const [redirectUrl, setRedirectUrl] = useState("")
  const [category, setCategory] = useState("")
  const [tilesData, setTilesData] = useState([])
  const [productsLoaded, setProductsLoaded] = useState(false)
  const [xfLink, setXfLink] = useState("")
  const [promoLayout, setPromoLayout] = useState("one-column")
  const [isGlobalConfigBlank, setIsGlobalConfigBlank] = useState(true)
  const [fusionFullCatalogResponse, setFusioFullCatalognResponse] = useState([])
  const [isSterling, setIsSterling] = useState(false)
  const [redirectTileToKohelerPLP, setRedirectTileToKohelerPLP] = useState("")
  const selectedFavoritesState = useSelector(selectFavoritesState)
  const { favorites } = selectedFavoritesState || {}
  const { lineItems = [] } = favorites || {}
  const { winWidth } = useWindowDimensions()

  useEffect(() => {
    if (showSearchBar) {
      setSearchHistory(JSON.parse(localStorage.getItem("keyWordList")) ?? [])
    }
  }, [showSearchBar])
  useEffect(() => {
    if (isGlobalConfigBlank) {
      getConfig()
        .then(async config => {
          let blankConfig = false
          if (!(config && Object.keys(config).length > 1)) {
            blankConfig = true
            setIsGlobalConfigBlank(true)
          }
          if (!blankConfig) {
            setIsGlobalConfigBlank(false)
            const vbrandName = await _get(config, "general.siteName", "")
            if (vbrandName) {
              setBrandName(vbrandName)
            }
            currencySign.current = _get(
              config,
              "internationalization.currencySign",
              ""
            )
            currencyCode.current = await _get(
              config,
              "internationalization.currencyCode",
              ""
            )
            knowledgeArticleUrl.current = await getShortenedUrl(
              _get(config, "general.knowledgeArticlePath", "")
            )
            searchPagePath.current = await getShortenedUrl(
              _get(config, "general.searchPagePath", "")
            )
            setRedirectTileToKohelerPLP(
              await getShortenedUrl(_get(config, "general.searchPagePath", ""))
            )
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }, [isSsr, isGlobalConfigBlank])

  useEffect(() => {
    if (data.presetConfigs) {
      dispatch(setSearchPresetConfig(data.presetConfigs))
    }
  }, [data.presetConfigs])

  const getEventInfoObj = (
    searchString,
    status,
    message,
    internalLinkURL,
    eventType,
    isserachButton,
    topSuggestedData
  ) => {
    const currDate = new Date()
    const contentType = window.eventPageType || ""
    const pageName =
      contentType === "homepage"
        ? "home"
        : (contentType && contentType.split("-")[0]) || ""
    const searchSuggestedTerm = []
    if (!analyticsEventData.searchString) {
      analyticsEventData.searchString = searchString
    }
    if (!analyticsEventData.searchTotal) {
      analyticsEventData.searchTotal = searchTotal
    }
    if (!analyticsEventData.topSuggestedData) {
      analyticsEventData.topSuggestedData = topSuggestedData
    }
    const searchSuggestions =
      searchHistory && searchHistory.length
        ? searchHistory
        : analyticsEventData.topSuggestedData &&
          analyticsEventData.topSuggestedData.length
        ? analyticsEventData.topSuggestedData
        : []
    if (searchSuggestions?.length) {
      searchSuggestions.slice(0, 5).map(item => {
        searchSuggestedTerm.push(
          sanitizeTextForAnalytics(item.productName_s || item.keyWord)
        )
      })
    }

    const eventseachName = isserachButton
      ? "internal search"
      : "internal automatic search"

    const names = topSuggestedData
      ? topSuggestedData
          ?.filter(obj => "productName_s" in obj)
          .map(function (obj) {
            return obj["productName_s"]
          })
      : null

    const topsuggestions = names ? names?.join("|")?.toLowerCase() : null

    const eventInfo = {
      eventName: eventseachName,
      eventAction: eventseachName,
      internalLinkName: "internal search icon",
      internalLinkType: "global header:navigation",
      internalLinkZoneName: "global header",
      clickInternalLinks: "true",
      eventType: "global header",
      internalLinkURL: internalLinkURL
        ? (internalLinkURL.indexOf("http") === -1
            ? window.location.origin
            : "") + internalLinkURL
        : "n/a",
      internalLinkPosition: "global header",
      eventMsg: status !== "success" ? message?.toLowerCase() : "n/a",
      eventStatus: status || "n/a",

      searchTerm: analyticsEventData.searchString,
      searchContentType: pageName ? pageName + " page" : "n/a",
      searchSuggestedTerm: topsuggestions ? topsuggestions : "n/a",
      searchCount: sessionStorage.getItem("searches")
        ? Number(sessionStorage.getItem("searches")) + 1
        : 1,
      searchResult: analyticsEventData.searchTotal,
      internalZoneName: "search:search box",
      pageURL: window.location.href,
      referrer: document.referrer || "n/a",
      previousPage: document.referrer || "n/a", // we can not get previous page name
      timeStamp:
        currDate.toISOString().split("T")[0] +
        " " +
        currDate.toTimeString().split(" ")[0],
      contentType: brandName?.toLowerCase(),
    }

    if (eventType?.type) {
      eventType.term = sanitizeTextForAnalytics(eventType.term)
      eventType.type = sanitizeTextForAnalytics(eventType.type)

      eventInfo.eventName = "search:" + eventType.type + ":search term"
      eventInfo.eventAction = "search:" + eventType.type + ":search term"
      eventInfo.internalLinkZoneName = "search:" + eventType.type
      if (eventType.type === "top suggestions") {
        eventInfo.searchTerm = analyticsEventData.searchString?.toLowerCase()
        eventInfo.searchSuggestedTerm = eventType.term
      } else {
        eventInfo.searchTerm = eventType.term
      }
      eventInfo.internalLinkName = eventType.term
      eventInfo.internalZoneName = "search:" + eventType.type
    }
    analyticsEventData = {}
    return eventInfo
  }
  const handleSearchAnalyticsEvent = (
    searchString,
    status,
    message,
    internalLinkURL,
    eventType,
    isserachButton,
    topSuggestedData
  ) => {
    if (!internalLinkURL) internalLinkURL = redirectUrl
    const eventInfo = getEventInfoObj(
      searchString,
      status,
      message,
      internalLinkURL,
      eventType,
      isserachButton,
      topSuggestedData
    )
    sessionStorage.setItem("searches", eventInfo.searchCount)
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    window.adobeDataLayer.push({
      event: "cmp:click",
      page,
      eventInfo,
    })
  }
  const handleRedirect = (
    searchTerm,
    isAnalyticsClick,
    analyticsEventType,
    isserachButton,
    topSuggestedData
  ) => {
    setProductsLoaded(false)
    setIsCTAClicked(true)
    if (redirectUrl) {
      isAnalyticsClick &&
        handleSearchAnalyticsEvent(
          searchTerm,
          "success",
          null,
          null,
          analyticsEventType
        )
      window.location.href = redirectUrl
      setRedirectUrl("")
    } else {
      let history = JSON.parse(window.localStorage.getItem("keyWordList")) ?? []
      history = history.filter(
        item => item.keyWord.toLowerCase() !== searchTerm.toLowerCase()
      )
      history.unshift({ keyWord: searchTerm, id: Date.now() })
      window.localStorage.setItem("keyWordList", JSON.stringify(history))

      dispatch(
        profileBrandSearch([
          searchTerm.trim(),
          brandName.toLowerCase(),
          "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
          1,
          "",
        ])
      )
        .then(async res => {
          if (res.payload) {
            let redirectLink = ""
            // redirect if redirect URL is configured in LW for search keyword
            if (
              res.payload.fusion &&
              res.payload.fusion.redirect &&
              res.payload.fusion.redirect[0]
            ) {
              redirectLink = res.payload.fusion.redirect[0]
              if (isAnalyticsClick) {
                searchTerm !== searchString // do not fire same events for unchanged search string
                  ? handleSearchAnalyticsEvent(
                      searchTerm,
                      "success",
                      null,
                      redirectLink,
                      analyticsEventType
                    )
                  : handleSearchAnalyticsEvent(
                      searchTerm,
                      "success",
                      null,
                      redirectLink,
                      analyticsEventType,
                      isserachButton,
                      topSuggestedData
                    )
              }
              window.location.href = redirectLink
            } // get PDP / article URL if only 1 result
            else if (
              res.payload.response.numFound === 1 &&
              res.payload.fusion.exactMatch
            ) {
              const d = res.payload.response.docs[0]
              if (d.slug_s) {
                const param = d.sku_s ? `skuId=${d.sku_s}` : ""
                const pdpUrl = await getPDPUrl(d.Product_Category, d.slug_s)
                redirectLink = getPdpRedirectUrl(pdpUrl, param)
              } else if (d.url_s) {
                redirectLink = d.url_s
              }
              isAnalyticsClick &&
                searchTerm !== searchString && // do not fire same events for unchanged search string
                handleSearchAnalyticsEvent(
                  searchTerm,
                  "success",
                  null,
                  redirectLink,
                  analyticsEventType
                )

              window.location.href = redirectLink
            }
            // get parts PDP URL if only 1 result
            else if (
              res.payload.fusion.partsCount === 1 &&
              res.payload.fusion.partsExactMatch
            ) {
              const d = res.payload.fusion.partsDocs[0]
              if (d.slug_s) {
                const param = d.sku_s ? `skuId=${d.sku_s}` : ""
                const pdpUrl = await getPDPUrl(null, d.slug_s)
                redirectLink = getPdpRedirectUrl(pdpUrl, param)
              } else if (d.url_s) {
                redirectLink = d.url_s
              }
              isAnalyticsClick &&
                searchTerm !== searchString && // do not fire same events for unchanged search string
                handleSearchAnalyticsEvent(
                  searchTerm,
                  "success",
                  null,
                  redirectLink,
                  analyticsEventType
                )

              window.location.href = redirectLink
            } else {
              redirectLink = sanitizeUrl(
                window.location.origin +
                  removeAndCleanLink(searchPagePath.current) +
                  `?keyword=${searchTerm.trim()}`
              )
              if (isAnalyticsClick) {
                searchTerm !== searchString // do not fire same events for unchanged search string
                  ? handleSearchAnalyticsEvent(
                      searchTerm,
                      "success",
                      null,
                      redirectLink,
                      analyticsEventType
                    )
                  : handleSearchAnalyticsEvent(
                      searchTerm,
                      "success",
                      null,
                      redirectLink,
                      analyticsEventType,
                      isserachButton,
                      topSuggestedData
                    )
              }
              window.location.href = redirectLink
            }
          }
          // setProductsLoaded(true)
        })
        .catch(err => {
          console.log("Error occured while fetching Search data", err)
          isAnalyticsClick &&
            handleSearchAnalyticsEvent(
              searchTerm,
              "failure",
              "error occured while fetching search data",
              null,
              analyticsEventType
            )
          setProductsLoaded(true)
        })
    }
  }

  const handleDelete = id => {
    let history = JSON.parse(window.localStorage.getItem("keyWordList")) ?? []
    history = history.filter(item => item.id !== id)
    window.localStorage.setItem("keyWordList", JSON.stringify(history))
    setSearchHistory(history)
  }

  const handleClearAll = () => {
    localStorage.removeItem("keyWordList")

    setSearchHistory([])
  }
  const handleChange = searchTerm => {
    setProductsLoaded(false)
    setSearchString(searchTerm.trim())
  }

  const searchingDebounced = useCallback(
    debounce((searchStr = "") => getData(searchStr), 300),
    [prevSearch]
  )

  useEffect(() => {
    if (brandName) {
      searchString.length >= 3
        ? (setPrevSearch(searchString), searchingDebounced(searchString))
        : setSearchTotal(0)
      setProductsLoaded(false)
    }
    return () => {
      searchingDebounced.cancel()
    }
  }, [searchString, brandName, searchingDebounced])

  const executeTypeaheadApi = (searchStr = "", brand = "") => {
    dispatch(profileBrandTypeahead([searchStr.trim(), brand.toLowerCase()]))
      .unwrap()
      .then(res => {
        const { response: { docs = [] } = {} } = res
        docs.length && setTopSuggestedData(docs)
      })
  }

  const getData = (searchStr = "") => {
    const { disableParts } = data
    if (redirectUrl) setRedirectUrl("")
    if (!isCTAClicked && searchStr.length >= 3) {
      executeTypeaheadApi(searchStr, brandName)

      dispatch(
        profileBrandSearch([
          searchStr.trim(),
          brandName.toLowerCase(),
          "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
          1,
          "",
        ])
      )
        .then(async res => {
          if (res.payload) {
            // get PDP / article URL if only 1 result
            if (
              res.payload.response.numFound === 1 &&
              res.payload.fusion.exactMatch
            ) {
              const d = res.payload.response.docs[0]
              if (d.slug_s) {
                const param = d.sku_s ? `skuId=${d.sku_s}` : ""
                const pdpUrl = await getPDPUrl(d.Product_Category, d.slug_s)
                setRedirectUrl(getPdpRedirectUrl(pdpUrl, param))
              } else if (d.url_s) {
                setRedirectUrl(d.url_s)
              }
            }
            // get parts PDP URL if only 1 result
            else if (
              res.payload.fusion.partsCount === 1 &&
              res.payload.fusion.partsExactMatch
            ) {
              const d = res.payload.fusion.partsDocs[0]
              if (d.slug_s) {
                const param = d.sku_s ? `skuId=${d.sku_s}` : ""
                const pdpUrl = await getPDPUrl(null, d.slug_s)
                setRedirectUrl(getPdpRedirectUrl(pdpUrl, param))
              }
            }
            setSearchProfileTotal(res.payload.response.numFound)
            let groups = [
              {
                key: "products",
                fq: 'Products:("ct")',
                count: _get(
                  res.payload,
                  "facet_counts.facet_fields.Products[1]",
                  0
                ),
              },
              {
                key: "parts",
                count: _get(
                  res.payload.fusion.partsCount,
                  "res.payload.fusion.partsCount",
                  0
                ),
              },
              {
                key: "technical",
                fq: 'Technical:("ct")',
                count: _get(
                  res.payload,
                  "facet_counts.facet_fields.Technical[1]",
                  0
                ),
              },
              {
                key: "inspiration",
                fq: 'Inspiration:("Inspiration")',
                count: _get(
                  res.payload,
                  "facet_counts.facet_fields.Inspiration[1]",
                  0
                ),
              },
              {
                key: "resource",
                fq: 'Resource:("Resource")',
                count: _get(
                  res.payload,
                  "facet_counts.facet_fields.Resource[1]",
                  0
                ),
              },
              {
                key: "help",
                fq: 'Help:("sf")',
                count: _get(
                  res.payload,
                  "facet_counts.facet_fields.Help[1]",
                  0
                ),
              },
            ]
            if (disableParts) {
              groups = groups.filter(arr => {
                return arr.key !== "parts"
              })
            }

            // Calculating the total results
            let total = 0
            const selected = groups.find(group => group.count > 0)
            if (
              res.payload.fusion.exactMatch ||
              res.payload.fusion.partsExactMatch
            ) {
              total =
                selected.key === "parts"
                  ? res.payload.response.numFound
                  : res.payload.fusion.partsCount
            } else {
              groups.forEach(group => (total += group.count))
            }
            analyticsEventData.searchTotal = total
            analyticsEventData.redirectUrl = redirectUrl
            analyticsEventData.topSuggestedData = { ...topSuggestedData }
            analyticsEventData.selectedData = selected
            analyticsEventData.searchString = searchStr.trim()
            setSearchTotal(total)
            setRedirectUrl(redirectUrl)
            const fullCatalogResponse = _get(
              res.payload,
              "fusion.full_catalog_Response",
              []
            )
            if (fullCatalogResponse.length > 0) {
              setIsSterling(true)
              setSearchTotal(1)
              setTopSuggestedData(fullCatalogResponse)
            }
            setFusioFullCatalognResponse(fullCatalogResponse)
            handleSearchAnalyticsEvent(searchStr, "success")
            setSelectedData(selected)
          }
        })
        .catch(err => {
          setProductsLoaded(true)
          console.error("Error occured while fetching Search data", err)
        })
    } else {
      setSearchTotal(0)
      setCategory("")
      setTilesData([])
      setRedirectUrl("")
      setTopSuggestedData([])
      setSearchProfileTotal(0)
    }
  }

  useEffect(() => {
    if (searchTotal > 0 && selectedData.key) {
      getTilesData(selectedData)
    }
  }, [searchTotal, selectedData])

  const getTilesData = selected => {
    const fl = [
      "id",
      "sku_s",
      "slug_s",
      "metaTitle_s",
      "productName_s",
      "masterSKU_s",
      "masterCustomerFacingSKU_s",
      "Product_Category",
      "ProductBrandName_s",
      "productImages.url_ss",
      "displayPriceStartingAt_s",
      "SKUColorSwatchFilename_ss",
      "ProductDescriptionProductShort_s",
      "url_s",
      "urlName_s",
      "title_s",
      "pageTitle_s",
      "eyeBrowText_s",
      "templateType_s",
      "thumbNailImage_s",
      "searchDescription_s",
      "layoutItems.Article_Type__c.value_s",
      "layoutItems.KM_Article_Content__c.value_s",
      "layoutItems.KBNA_3C_Image_Video__c.label_s",
      "layoutItems.KBNA_3C_Image_Video__c.value_s",
      `priceList.${persona}.price_d`,
      `priceList.${persona}.finalPrice_d`,
      `priceList.${persona}.discountedPrice_d`,
      `priceList.${persona}.saleOffer_s`,
      `priceStartingAt.${persona}_d`,
      `discountedPriceStartingAt.${persona}_d`,
      "Color.SKU.Details_ss",
      `Color.${persona}.Details_ss`,
      "ProductIsExclusive_s",
      "RegionReleaseforShipment_dt",
      "productImages.labelWithUrl_ss",
      "variantList.sku_ss",
      "RegionOnBackOrder_s",
      "RegionBrandName_s",
      "ctId_s",
      "primaryBundleSKU_s",
      "pdp_url_s",
    ]
    setXfLink("")
    setPromoLayout("one-column")
    setCategory("")
    setTilesData([])

    dispatch(
      selected.key === "parts"
        ? profileServicePartsSearch([searchString.trim(), fl.join(","), 6])
        : profileBrandSearch([
            searchString.trim(),
            brandName.toLowerCase(),
            fl.join(","),
            6,
            selected.fq,
          ])
    ).then(res => {
      if (res.payload && res.payload.response?.docs) {
        setCategory(selected.key)
        setTilesData(res.payload.response?.docs)
        if (fusionFullCatalogResponse?.length > 0) {
          setTilesData(fusionFullCatalogResponse)
        }
        if (
          res.payload.fusion &&
          res.payload.fusion.experiment_fragments &&
          res.payload.fusion.experiment_fragments !== undefined
        ) {
          setPromoLayout(
            res.payload.fusion?.experiment_fragments[0]?.promoLayout_s ??
              "one-column"
          )
          setXfLink(res.payload.fusion?.experiment_fragments[0]?.url_s ?? "")
        }
      }

      setProductsLoaded(true)
    })
  }
  const bodyRef = useRef(document.body)
  const htmlRef = useRef(document.getElementsByTagName("html")[0])
  const handleToggle = () => {
    showSearchBar
      ? addMavenoidChat()
      : isMobile
      ? removeMavenoidChat()
      : addMavenoidChat()
    setSearchString("")
    setSearchTotal(0)
    const classNames = ["searchbar-open", "scroll-lock"]
    classNames.map(className => bodyRef?.current?.classList?.toggle(className))
    classNames.map(className => htmlRef?.current?.classList?.toggle(className))
    setShowSearchBar(!showSearchBar)
    const page = window.pageObj || {}
    const previousPageNameForSearch = page?.pageInfo?.pageName
    sessionStorage.setItem(
      "previousPageNameForSearch",
      previousPageNameForSearch
    )
  }
  const handleLogin = e => {
    e.preventDefault()
    isAuth
      ? router.push("/en/my-account/my-favorites")
      : dispatch(setAuthModalVisibility({ show: true }))
  }

  const themeChange =
    typeof window !== "undefined" &&
    winWidth <= 1200 &&
    (document.body.classList.contains("nav-light-theme") ||
      document.body.classList.contains("nav-dark-theme"))

  return (
    <div className={utilityStyles.utilityWidgetsWrapper}>
      <div
        className={`utilitywidgets ${columnClassNames ? columnClassNames : ""}`}
      >
        <div role="list" className="utility-widgets">
          <div role="listitem" className="search-widget">
            <div>
              <button
                className="search-button gbh-data-layer bg-transparent"
                tabIndex="0"
                role="button"
                aria-label="Search"
                data-gbh-data-layer={`{"eventAction":"internal search","eventName":"internal search","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"internal search magnifying glass button","internalLinkPosition":"global header","internalLinkType":"global navigation","internalLinkZoneName":"global header","internalLinkURL":"n/a","clickInternalLinks":"true"}`}
                onClick={handleToggle}
              >
                <span className="search-text">{searchHeader}</span>
                <span className="search-icon">
                  {themeChange ? (
                    <img
                      role="presentation"
                      src={iconSearch}
                      alt="search-icon"
                    />
                  ) : (
                    <img
                      role="presentation"
                      src="data:image/svg+xml;base64,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"
                      alt="search-icon"
                    />
                  )}
                </span>
              </button>
              {showSearchBar && (
                <SearchPanel
                  showSearchBar={showSearchBar}
                  onToggle={handleToggle}
                  onRedirect={handleRedirect}
                  onChange={handleChange}
                  searchString={searchString}
                  brand={brandName}
                  searchTotal={searchTotal}
                  topSuggestedData={topSuggestedData}
                  searchHistory={searchHistory}
                  xfLink={xfLink}
                  category={category}
                  removeFromCompare={removeFromCompareProduct}
                  addToCompare={addToCompareProduct}
                  tilesData={tilesData}
                  productsLoaded={productsLoaded}
                  promoLayout={promoLayout}
                  favorites={getFavouraties()?.lineItems}
                  comparedProducts={getCompareData()}
                  currencySign={currencySign.current}
                  knowledgeArticleUrl={knowledgeArticleUrl.current}
                  presetConfigs={data.presetConfigs}
                  onDelete={handleDelete}
                  onClearAll={handleClearAll}
                  isSterling={isSterling}
                  sterlingData={fusionFullCatalogResponse}
                  parent={"Utility Widgets"}
                  searchPagePath={redirectTileToKohelerPLP}
                  searchProfileTotal={searchProfileTotal}
                />
              )}
            </div>
          </div>
          <div role="listitem" className="wishlist-widget d-lg-none">
            <div
              aria-label="View your wishlist"
              className="gbh-data-layer"
              onClick={handleLogin}
            >
              <img
                aria-hidden="true"
                alt="Wishlist"
                src={
                  lineItems && lineItems.length > 0
                    ? FULL_FAVORITE_BASE64
                    : EMPTY_FAVORITE_BASE64
                }
              />
            </div>
          </div>
          {!data?.disableMiniCart && (
            <div role="listitem" className="cart-indicator-widget d-lg-none">
              <MiniCart source={"from mobile"} eventHandler={eventHandler} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default UtilityWidgets
